import { render, staticRenderFns } from "./editK3.vue?vue&type=template&id=488e309a&"
import script from "./editK3.vue?vue&type=script&lang=js&"
export * from "./editK3.vue?vue&type=script&lang=js&"
import style0 from "./editK3.vue?vue&type=style&index=0&id=488e309a&prod&lang=less&"
import style1 from "./editK3.vue?vue&type=style&index=1&id=488e309a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports